import { useState } from 'react';
import { pick } from 'lodash/object';

export const CollectACHDetailsWithStreetAddressFlow = ({ recipientLogin, children }) => {
  const [isFetching, setIsFetching] = useState(false);

  const onSubmit = async (formData) => {
    try {
      setIsFetching(true);

      // sample form data based on the form fields in the CollectACHDetailsView
      // const formData = {
      //   address: {
      //     street_address_line_1: '',
      //     street_address_line_2: '',
      //     city: '',
      //     state: '',
      //     postal_code: '',
      //     country: '',
      //     google_formatted_address: '',
      //   },
      //   ach: {
      //     name_on_account: '',
      //     account_number: '',
      //     routing_number: '',
      //     account_type: '',
      //   },
      // };

      const { address, ach } = formData;

      // map data to format expected by /recipientLogins
      const dataForRecipientLogin = {
        street_address_1: address.street_address_1,
        city: address.city,
        state: address.state,
        postal_code: address.postal_code,
        account_number: ach.account_number,
        bank_code: ach.routing_number,
        account_type: ach.account_type,
        name: ach.name_on_account,
        google_raw_data: address.google_place_raw,
        manual_edit: address.manual_edit,
      };

      if (address.street_address_line_2) {
        dataForRecipientLogin.street_address_2 = address.street_address_2;
      }

      // don't log bank account info
      const dataForLogs = pick(dataForRecipientLogin, [
        'street_address_1',
        'street_address_2',
        'city',
        'state',
        'postal_code',
        'name',
        'google_raw_data',
        'manual_edit',
      ]);

      await recipientLogin({
        dataForRecipientLogin,
        skipDefaultPostEffects: false,
        customLogData: dataForLogs,
      });

      // example response from /recipientLogins
      // const {
      //   accessToken,
      //   additionalData: {
      //     networkResponse: {
      //       payment_instrument: {
      //         name,
      //         bank_code,
      //         masked_account_number: { account_number },
      //         account_type,
      //         created_at,
      //         updated_at,
      //       },
      //     },
      //   },
      // } = recipientLoginResponse;
    } catch (error) {
      setIsFetching(false);
    }
  };

  return children({
    onSubmit,
    isFetching,
  });
};

export default CollectACHDetailsWithStreetAddressFlow;
